/* Conguitos · selector de vista exclusivo de Novedades editoriales. */
(() => {
  const selector = '[data-novedades-editorial]';

  function normaliseLayout(value) {
    return value === 'grid' ? 'grid' : 'editorial';
  }

  function applyLayout(root, requestedLayout) {
    const layout = normaliseLayout(requestedLayout);
    root.dataset.novedadesLayout = layout;

    root.querySelectorAll('[data-novedades-layout-toggle]').forEach((button) => {
      const active = button.dataset.novedadesLayoutToggle === layout;
      button.setAttribute('aria-pressed', active ? 'true' : 'false');
      button.toggleAttribute('aria-current', active);
    });
  }

  function initialise(root) {
    if (!root || root.dataset.novedadesInitialised === 'true') return;

    root.dataset.novedadesInitialised = 'true';
    applyLayout(root, root.dataset.novedadesLayout);

    root.addEventListener('click', (event) => {
      const button = event.target.closest('[data-novedades-layout-toggle]');
      if (!button || !root.contains(button)) return;

      event.preventDefault();
      applyLayout(root, button.dataset.novedadesLayoutToggle);
    });
  }

  function initialiseAll(scope = document) {
    if (scope.matches?.(selector)) initialise(scope);
    scope.querySelectorAll?.(selector).forEach(initialise);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initialiseAll());
  } else {
    initialiseAll();
  }

  document.addEventListener('shopify:section:load', (event) => initialiseAll(event.target));
})();
